import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonOptions } from '../interfaces/common-options';
import { StaffProfile } from '../interfaces/staff/staff-profile';
import { StaffAuditCount } from '../interfaces/staff/staff-audit-count';

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  constructor(private httpClient: HttpClient) {}

  getStaffOptions(): Observable<CommonOptions[]> {
    return this.httpClient.get<CommonOptions[]>(`/api/staffs/options`);
  }

  getStaffProfile(): Observable<StaffProfile> {
    return this.httpClient.get<StaffProfile>(`/api/me`);
  }

  getStaffAuditCount(): Observable<StaffAuditCount> {
    return this.httpClient.get<StaffAuditCount>(`/api/staffs/auditCount`);
  }
}
